import clsx from "clsx";
import React, { FC, useMemo } from "react";

import { AppendixCard } from "../../cards/appendix-card";
import { ImageCard } from "../../cards/image-card";
import { MaterialCard } from "../../cards/material-card";

export interface BannerCardsItemProps {
  cardProps:
    | Queries.AppendixCardDataFragment
    | Queries.ImageCardDataFragment
    | Queries.MaterialCardDataFragment;
  className?: string;
}

export const BannerCardsItem: FC<BannerCardsItemProps> = ({ cardProps, className }) => {
  const cardEl = useMemo(() => {
    switch (cardProps.__typename) {
      case "ContentfulAppendixCard":
        return <AppendixCard {...cardProps} />;
      case "ContentfulImageCard":
        return <ImageCard {...cardProps} keepOriginalAspectRatio={false} className="min-h-120" />;
      case "ContentfulMaterialCard":
        return <MaterialCard {...cardProps} className="min-h-120" />;
      default:
        return null;
    }
  }, [cardProps]);

  return <div className={clsx("h-full", className)}>{cardEl}</div>;
};
